import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";

function ModalDialog(props) {
  const handleClose_true = () => {
    props.handleClose(true);
  };
  const handleClose_false = () => {
    props.handleClose(false);
  };

  return (
    <div>
      <Dialog
        open={props.open}
        onClose={handleClose_false}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{props.title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {props.question}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose_false} color="primary" autoFocus>
            Nee
          </Button>
          <Button onClick={handleClose_true} color="primary">
            Ja
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default ModalDialog;
